import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMultiMedia: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="multi-media, media, image-video"><path d="M15.25 8.75V2.75H2.75V15.25H8.75M3.1 11.9L6 10L8.37885 11.5859M6 6.25H6.5M14.5 15.0002H15M8.75 8.75H21.25V21.25H8.75V8.75ZM6.75 6.25C6.75 6.52614 6.52614 6.75 6.25 6.75C5.97386 6.75 5.75 6.52614 5.75 6.25C5.75 5.97386 5.97386 5.75 6.25 5.75C6.52614 5.75 6.75 5.97386 6.75 6.25ZM13.75 13.3V16.7L16.5 15L13.75 13.3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMultiMedia;
